"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HitAreaRenderer = void 0;
var CompoundHitArea_1 = require("../Input/CompoundHitArea");
var PixelPerfectHitArea_1 = require("../Input/PixelPerfectHitArea");
var PixiUtils = require("../Utils/PixiUtils");
/**
 * Hit area renderer
 */
var HitAreaRenderer = /** @class */ (function (_super) {
    __extends(HitAreaRenderer, _super);
    function HitAreaRenderer(pRoot, pActive, pInterval) {
        if (pActive === void 0) { pActive = false; }
        if (pInterval === void 0) { pInterval = 0; }
        var _this = _super.call(this) || this;
        _this._root = pRoot;
        _this._interval = pInterval;
        _this._elapsed = 0;
        _this._active = pActive;
        _this._graphics = new PIXI.Graphics();
        _this.addChild(_this._graphics);
        return _this;
    }
    Object.defineProperty(HitAreaRenderer.prototype, "active", {
        /**
         * Gets active
         */
        get: function () {
            return this._active;
        },
        /**
         * Sets active
         */
        set: function (pValue) {
            this._active = pValue;
            if (this._active === false) {
                this.clear();
            }
            else {
                this.renderHitAreas();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HitAreaRenderer.prototype, "interval", {
        /**
         * Sets interval
         */
        set: function (pValue) {
            this._interval = pValue;
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @param pDeltaTime
     */
    HitAreaRenderer.prototype.update = function (pDeltaTime) {
        if (this._active) {
            if (this._interval > 0) {
                this._elapsed += pDeltaTime;
            }
            if (this._elapsed >= this._interval) {
                this._elapsed %= this._interval;
                this.renderHitAreas();
            }
        }
    };
    /**
     * Renders hit area renderer
     */
    HitAreaRenderer.prototype.renderHitAreas = function () {
        this._graphics.clear();
        this._graphics.beginFill(0xFF0000, 0.25);
        this.renderRecursive(this._root);
        this._graphics.endFill();
    };
    /**
     * Clears hit area renderer
     */
    HitAreaRenderer.prototype.clear = function () {
        this._graphics.clear();
    };
    /**
     * Renders recursive
     * @param pTarget
     * @returns recursive
     */
    HitAreaRenderer.prototype.renderRecursive = function (pTarget) {
        if (pTarget.interactive === true && pTarget.worldVisible === true) {
            this.renderTarget(pTarget);
        }
        if ((pTarget instanceof PIXI.Container) === false || pTarget.children.length === 0) {
            return;
        }
        else if ((pTarget instanceof PIXI.Container)) {
            if (pTarget.interactiveChildren === true) {
                for (var i = 0; i < pTarget.children.length; ++i) {
                    this.renderRecursive(pTarget.children[i]);
                }
            }
        }
    };
    /**
     * Renders target
     * @param pTarget
     */
    HitAreaRenderer.prototype.renderTarget = function (pTarget) {
        var matrixTransform = new PIXI.Transform();
        pTarget.parent.worldTransform.decompose(matrixTransform);
        var parentScale = new PIXI.Point(matrixTransform.scale.x / this.parent.scale.x, matrixTransform.scale.y / this.parent.scale.y);
        var globalScale = new PIXI.Point(parentScale.x * pTarget.scale.x, parentScale.y * pTarget.scale.y);
        var hitArea = pTarget.hitArea;
        var pos = pTarget.getGlobalPosition();
        // Account for scaling of the Stage
        pos.x *= 1 / this.parent.scale.x;
        pos.y *= 1 / this.parent.scale.y;
        // TODO:SH: Account for target scale (need to find a way to parse the worldTransform)
        if (hitArea instanceof PIXI.Rectangle || hitArea instanceof PIXI.RoundedRectangle ||
            hitArea instanceof PIXI.Circle || hitArea instanceof PIXI.Ellipse || hitArea instanceof PIXI.Polygon) {
            var clone = hitArea.clone();
            this._graphics.drawShape(PixiUtils.offsetShape(clone, pos));
        }
        else if (hitArea instanceof CompoundHitArea_1.CompoundHitArea) {
            for (var i = 0; i < hitArea.components.length; ++i) {
                var clone = hitArea.components[i].clone();
                this._graphics.drawShape(PixiUtils.offsetShape(clone, pos));
            }
        }
        else if (hitArea instanceof PixelPerfectHitArea_1.PixelPerfectHitArea) {
            for (var x = 0; x < hitArea.width; ++x) {
                for (var y = 0; y < hitArea.height; ++y) {
                    if (hitArea.getHitAreaAtPixel(x, y)) {
                        this._graphics.drawRect(pos.x - (hitArea.scaledWidth * 0.5 * globalScale.x) + (x * globalScale.x), pos.y - (hitArea.scaledHeight * 0.5 * globalScale.y) + (y * globalScale.y), globalScale.x, globalScale.y);
                    }
                }
            }
        }
    };
    return HitAreaRenderer;
}(PIXI.Container));
exports.HitAreaRenderer = HitAreaRenderer;
//# sourceMappingURL=HitAreaRenderer.js.map